import http from "./http";

/**
 * 按天汇总（已过滤未 published 的期）
 * GET /api/player/report/daily
 */
export const getReportDailyApi = (startDate, endDate) =>
    http.get("/api/player/report/daily", {
        params: { startDate, endDate }
    });

/**
 * 某一天的投注明细
 * GET /api/player/report/detail?date=2026-01-06
 */
export const getReportDetailApi = (date) =>
    http.get("/api/player/report/detail", {
        params: { date }
    });
